import { workspaceUserCompareValue } from "@common-models/workspace-user";
import { MenuList } from "@mui/material";
import { AugmentedBlueticksBoardUser, cellPersonListSelector, getSelectedBoardCompleteUserList } from "@common-reducers/BoardsSelectors";
import { pickerDialogActions } from "@common-reducers/PickerDialogReducer";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { memo, useMemo, useState } from "react";
import { PickerProps } from "../columns-cells/cell-interface";
import { PersonPickerValue } from "../columns-cells/person-picker-cell/person-picker-cell";
import PersonPickerMappedOptions from "./person-picker-mapped-options";
import { cellValueSelector } from "@common-reducers/TaskSelectors";
import { updateCellValueThunk } from "@common-reducers/TaskThunks";

function PersonPicker({
  taskId,
  columnId,
  boardId
}: PickerProps) {
  const dispatch = useAppDispatch()

  // const isBoardOwner = useAppSelector(isCurrentBoardOwnerSelector)
  const _boardMemberList: AugmentedBlueticksBoardUser[] = useAppSelector((state) => (getSelectedBoardCompleteUserList(state, boardId ?? undefined)));
  const cellValue: PersonPickerValue[] = useAppSelector((state) => cellValueSelector(state, taskId, columnId))
  const cellPersonList: AugmentedBlueticksBoardUser[] = useAppSelector(state => cellPersonListSelector(state, cellValue, boardId ?? undefined));
  const [searchedPersonName, setValue] = useState('')
  // const [isEditing, setIsEditing] = useState(false);
  // const [newPersonName, setNewPersonName] = useState('');
  // const [imgUrl, setImgUrl] = useState('')
  // const [imgColor, setImgColor] = useState('')

  const isMac = navigator?.platform.indexOf('Mac') > -1;
  const ctrlOrMetakey = isMac ? '⌘' : 'Ctrl'

  const boardMemberList = useMemo(() => [..._boardMemberList], [_boardMemberList])

  const selectedPersonsIds = useMemo(() => boardMemberList.filter(option => cellPersonList?.some((value: AugmentedBlueticksBoardUser) => value._id === option._id)).map(s => s._id), [boardMemberList, cellPersonList])
  const filteredBoardMemberList = boardMemberList.filter(option => !selectedPersonsIds.includes(option._id));

  const filterPeopleList = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)

  }
  const toggleMenu = () => {
    dispatch(pickerDialogActions.closePickerDialog());
  }

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Tab") {
      event.preventDefault();
      toggleMenu();
    }
  }

  const cellPersonListToValue = (personList: AugmentedBlueticksBoardUser[]) => personList.map(person => {
    let val;
    switch (person.type) {
      case 'user': {
        ;
        val = { id: person._id, type: 'user' }
        break;
      }
      case 'option': {
        val = { id: person._id, type: 'option' }
        break;
      }
    }
    return val;
  })

  const onValueUpdate = (e: React.MouseEvent | React.KeyboardEvent, targetPerson: AugmentedBlueticksBoardUser) => {
    console.log(cellPersonList);
    let personList: AugmentedBlueticksBoardUser[] = [];

    if (e.metaKey || e.ctrlKey) {
      personList = [
        ...(cellPersonList ?? []),
        targetPerson
      ]
    } else {
      personList = [targetPerson]
    }

    personList.sort((a, b) => workspaceUserCompareValue(a).localeCompare(workspaceUserCompareValue(b)));
    const value = cellPersonListToValue(personList);
    console.log(value);

    dispatch(updateCellValueThunk({
      taskId: taskId ?? null,
      columnId: columnId ?? null,
      data: {
        value
      }
    }));

    if (!e.metaKey && !e.ctrlKey) {
      toggleMenu();
    }

  }

  const clearValue = (value: AugmentedBlueticksBoardUser) => {
    dispatch(updateCellValueThunk({
      taskId: taskId ?? null,
      columnId: columnId ?? null,
      data: {
        value: cellPersonListToValue(cellPersonList.filter((cellPerson: AugmentedBlueticksBoardUser) => cellPerson._id !== value._id))
      }
    }));
  }

  // const canEdit = useMemo(() => columnId && !isTempId(columnId), [columnId])

  // const handleSave = () => {
  //   dispatch(createMockPersonThunk({
  //     columnId,
  //     newPersonName,
  //     imgUrl,
  //     imgColor,
  //   }));
  //   setIsEditing(false)
  //   setImgColor('')
  //   setImgUrl('')
  //   setNewPersonName('')

  // }

  // const handleCancel = () => {
  //   setIsEditing(false)
  //   setImgColor('')
  //   setImgUrl('')
  //   setNewPersonName('')

  // }


  return (
    <MenuList
      autoFocusItem={true}
      id="menu-list-grow"
      onKeyDown={handleListKeyDown}
      sx={{
        backgroundColor: 'var(--color-surface)',
        border: '2px solid var(--color-surface)',
        borderLeft: '20px solid var(--color-surface)',
        borderRight: '20px solid var(--color-surface)',
        borderRadius: '10px',
        margin: '-4px',
      }}
    >

      <PersonPickerMappedOptions
        cellPersonList={cellPersonList}
        clearValue={clearValue}
        searchedPersonName={searchedPersonName}
        filterPeopleList={filterPeopleList}
        setValue={setValue}
        filteredBoardMemberList={filteredBoardMemberList}
        onValueUpdate={onValueUpdate}
        boardMemberList={boardMemberList}
        ctrlOrMetakey={ctrlOrMetakey}
        // isEditing={isEditing}
      />



      {/* currently we hide this => false */}
      {/* {false && isBoardOwner &&
        <div className={classes.edit_labels_button_wrap}>
          {!isEditing &&
            <Button
              onClick={() => setIsEditing(true)}
              disabled={!canEdit}
              className={classes.edit_labels_button}
              style={{
                textTransform: "capitalize",
                marginTop: 5,
                boxShadow: "none",
                fontSize: 12,
                borderRadius: 0,
                color: '#063448',
              }}
            >
              <BiPencil size={16} />
              <p style={{
                margin: '0px 5px',
                fontFamily: "'Inter', sans-serif",
                fontWeight: "600",
                fontSize: 14,
              }}>
                Edit People
              </p>
            </Button>
          }
          {isEditing &&
            <>
              <PersonPickerEditableOptions
                newPersonName={newPersonName}//
                setNewPersonName={setNewPersonName}//
                columnId={columnId}
                imgUrl={imgUrl} //
                setImgUrl={setImgUrl}
                imgColor={imgColor}//
                setImgColor={setImgColor}
              />
              <Stack direction='row'>
                <Button
                  onClick={() => handleSave()}
                  disabled={!(newPersonName !== '')}
                  className={classes.edit_labels_button}
                  style={{
                    textTransform: "capitalize",
                    marginTop: 5,
                    boxShadow: "none",
                    fontSize: 12,
                    borderRadius: 0,
                    color: '#063448',
                  }}
                >
                  <BiSave size={16} />
                  <p style={{
                    margin: '0px 5px',
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "600",
                    fontSize: 14,
                  }}>
                    Save
                  </p>
                </Button>
                <Button
                  onClick={() => handleCancel()}
                  className={classes.edit_labels_button}
                  style={{
                    textTransform: "capitalize",
                    marginTop: 5,
                    boxShadow: "none",
                    fontSize: 12,
                    borderRadius: 0,
                    color: '#063448',
                  }}
                >
                  <BiX size={16} />
                  <p style={{
                    margin: '0px 5px',
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "600",
                    fontSize: 14,
                  }}>
                    Close
                  </p>
                </Button>
              </Stack>
            </>

          }
        </div>
      } */}

    </MenuList>
  );
}

export default memo(PersonPicker);
